<div class="main-content pick-station-shell">
<div class="pick-station" [class.is-order]="mode === 'order'">

	<!-- ══════════════════ QUEUE ══════════════════ -->
	<ng-container *ngIf="mode === 'queue'">

		<header class="ps-header">
			<div class="ps-head-icon" [class.is-check]="stage === 'check'">
				<i class="material-icons">{{ stage === 'check' ? 'fact_check' : 'inventory' }}</i>
			</div>
			<div class="ps-head-text">
				<div class="ps-title">{{ stageTitle }}</div>
				<div class="ps-sub">{{ me }}<span *ngIf="location"> · {{ location }}</span></div>
			</div>
			<button type="button" class="icon-btn" (click)="loadQueue()" aria-label="Refresh queue">
				<i class="material-icons">refresh</i>
			</button>
		</header>

		<!-- Scan an order barcode to jump straight in. -->
		<section class="scan-bar" (click)="focusSink()">
			<input #dwSink class="dw-sink" type="text" autocomplete="off" autocorrect="off"
				autocapitalize="off" spellcheck="false" inputmode="none" tabindex="0"
				(input)="onSinkInput($event)" />
			<div class="scan-ready" [class.scanning]="keyBuffer.length > 0"
				[class.mode-manual]="scanMode === 'manual'" (click)="toggleManual()">
				<i class="material-icons">{{ keyBuffer.length ? 'wifi_tethering' : (scanMode === 'manual' ? 'edit' : 'qr_code_scanner') }}</i>
				<div class="scan-text">
					<span class="scan-label">{{ keyBuffer.length ? 'Scanning…' : (scanMode === 'manual' ? 'Type an order #' : 'Scan an order') }}</span>
					<span class="scan-last" *ngIf="!keyBuffer.length && lastScanned">Last: {{ lastScanned }}</span>
				</div>
				<span class="scan-buf" *ngIf="keyBuffer.length">{{ keyBuffer }}</span>
			</div>
			<div class="manual-row" *ngIf="scanMode === 'manual'" (click)="$event.stopPropagation()">
				<i class="material-icons">keyboard</i>
				<input #manualInput type="text" inputmode="numeric" autocomplete="off"
					placeholder="Order number…" (keydown.enter)="onManualEnter($event)" />
			</div>
		</section>

		<section class="ps-filters">
			<button type="button" class="pf" [class.on]="filter === 'all'" (click)="setFilter('all')">
				<span class="pf-val">{{ countFor('all') }}</span><span class="pf-lbl">All</span>
			</button>
			<button type="button" class="pf mine" [class.on]="filter === 'mine'" (click)="setFilter('mine')">
				<span class="pf-val">{{ countFor('mine') }}</span><span class="pf-lbl">Mine</span>
			</button>
			<button type="button" class="pf open" [class.on]="filter === 'open'" (click)="setFilter('open')">
				<span class="pf-val">{{ countFor('open') }}</span><span class="pf-lbl">{{ openLabel }}</span>
			</button>
			<button type="button" class="pf ready" [class.on]="filter === 'ready'" (click)="setFilter('ready')">
				<span class="pf-val">{{ countFor('ready') }}</span><span class="pf-lbl">{{ doneLabel }}</span>
			</button>
		</section>

		<section class="ps-search">
			<i class="material-icons">search</i>
			<input type="text" [(ngModel)]="search" placeholder="Order #, customer or city" autocomplete="off" />
			<button type="button" class="icon-btn small" *ngIf="search" (click)="search = ''" aria-label="Clear search">
				<i class="material-icons">clear</i>
			</button>
		</section>

		<div class="ps-loading" *ngIf="loading">
			<mat-progress-spinner mode="indeterminate" diameter="40" color="accent"></mat-progress-spinner>
		</div>

		<div class="ps-error" *ngIf="error">
			<i class="material-icons">error</i> {{ error }}
		</div>

		<section class="order-list" *ngIf="!loading">
			<article class="order-card" *ngFor="let r of visibleRows; trackBy: trackByOrderno"
				[ngClass]="rowTone(r)" (click)="openOrder(r)">

				<div class="oc-top">
					<span class="oc-no">#{{ r.orderno }}</span>
					<span class="oc-flag late" *ngIf="r.late">LATE</span>
					<span class="oc-flag asap" *ngIf="r.asap && !r.late">ASAP</span>
					<span class="oc-flag short" *ngIf="r.short_lines > 0">SHORT</span>
					<span class="oc-spacer"></span>
					<span class="oc-cut" *ngIf="r.cutoff_label">{{ r.cutoff_label }}</span>
				</div>

				<div class="oc-cust">{{ r.customer }}</div>
				<div class="oc-meta">
					<span *ngIf="r.city">{{ r.city }}</span>
					<span *ngIf="r.shipvia">· {{ r.shipvia }}</span>
					<span *ngIf="r.bin_range" class="bins"><i class="material-icons">grid_view</i>{{ r.bin_range }}</span>
					<span class="age">· {{ age(r) }}</span>
				</div>

				<div class="oc-prog">
					<div class="oc-nums">
						<strong>{{ r.lines_done }}/{{ r.line_count }}</strong> lines
						<span class="dot">·</span>
						{{ r.qty_picked | number:'1.0-0' }}/{{ r.qty_pick | number:'1.0-0' }} units
					</div>
					<div class="bar"><div class="fill" [style.width.%]="r.pct"></div></div>
				</div>

				<div class="oc-actions">
					<button type="button" class="claim-btn" [class.mine]="r.claimed_user === me"
						(click)="claim(r, $event)"
						[attr.aria-label]="r.claimed_user === me ? 'Release this order' : 'Claim this order'">
						<i class="material-icons">{{ r.claimed_user === me ? 'how_to_reg' : 'pan_tool' }}</i>
						<span>{{ r.claimed_user ? (r.claimed_user === me ? 'Mine' : r.claimed_user) : 'Claim' }}</span>
					</button>
					<button type="button" class="go-btn" (click)="openOrder(r); $event.stopPropagation()">
						{{ r.bucket === 'ready' ? 'Review' : (r.bucket === 'in_progress' ? 'Resume' : startLabel) }}
						<i class="material-icons">arrow_forward</i>
					</button>
				</div>
			</article>

			<div class="ps-empty" *ngIf="!visibleRows.length && !error">
				<i class="material-icons">{{ search || filter !== 'all' ? 'filter_list' : 'check_circle' }}</i>
				<p *ngIf="search || filter !== 'all'">Nothing matches this filter.</p>
				<p *ngIf="!search && filter === 'all'">{{ emptyLine }}</p>
				<button type="button" class="text-btn" *ngIf="search || filter !== 'all'"
					(click)="search = ''; setFilter('all')">Show everything</button>
			</div>
		</section>
	</ng-container>

	<!-- ══════════════════ ORDER ══════════════════ -->
	<ng-container *ngIf="mode === 'order'">

		<header class="order-head" [class.all-done]="allPicked" (click)="toggleDetail()">
			<button type="button" class="icon-btn back" (click)="backToQueue(); $event.stopPropagation()" aria-label="Back to queue">
				<i class="material-icons">arrow_back</i>
			</button>
			<div class="oh-info">
				<div class="oh-no">#{{ orderno }}</div>
				<div class="oh-cust" *ngIf="header">{{ header.customer }}</div>
			</div>
			<div class="oh-prog" *ngIf="header">
				<div class="oh-count">{{ totals.lines_done }}/{{ totals.line_count }}</div>
				<div class="oh-lbl">lines</div>
			</div>
			<button type="button" class="icon-btn" *ngIf="header" (click)="toggleDensity($event)"
				[attr.aria-label]="density === 'compact' ? 'Bigger rows' : 'Fit more lines'"
				[title]="density === 'compact' ? 'Bigger rows' : 'Fit more lines'">
				<i class="material-icons">{{ density === 'compact' ? 'view_agenda' : 'view_list' }}</i>
			</button>
			<button type="button" class="icon-btn" *ngIf="header" (click)="printSlip($event)"
				[disabled]="printing" [attr.aria-label]="'Print ' + stage + ' slip'">
				<i class="material-icons">{{ printing ? 'hourglass_top' : 'print' }}</i>
			</button>
			<i class="material-icons chevron" *ngIf="header">{{ expandedDetail ? 'expand_less' : 'expand_more' }}</i>
		</header>
		<div class="oh-track" *ngIf="header">
			<div class="oh-fill" [style.width.%]="totals.pct" [class.full]="totals.pct >= 100"></div>
		</div>

		<!-- The header facts a printed sheet keeps in view the whole time. Tapping
		     the header still opens the full detail card; this is the always-on line. -->
		<div class="oh-strip" *ngIf="header">
			<span class="s-asap" *ngIf="header.asap">ASAP</span>
			<span *ngIf="header.city">{{ header.city }}</span>
			<span *ngIf="header.deliverydate">{{ header.deliverydate | date:'EEE MMM d' }}</span>
			<span *ngIf="header.shipvia">{{ header.shipvia }}</span>
			<span *ngIf="header.customerref">PO {{ header.customerref }}</span>
			<span class="s-tally">{{ totals.bin_count }} {{ groupNoun }} · {{ totals.qty_pick | number:'1.0-0' }} units</span>
		</div>

		<!-- Everything the picker might need about the order, out of the way until asked for. -->

		<!-- On a phone this is one column in the order it always was: facts, scan bar,
		     then the lines. On a desktop or a landscape iPad the same markup becomes two
		     columns — the lines take the width they were never getting, and the facts and
		     scanner move into a rail that stays put instead of pushing the work down the
		     page. Same DOM order, so nothing changes for the narrow case. -->
		<div class="order-body">

			<aside class="order-rail">
			<!-- Always in the DOM; visibility is CSS. Gating it on a width flag in TS meant
			     the flag could go stale (an iPad rotating to landscape kept the old layout),
			     and a media query cannot. -->
			<section class="order-detail" [class.collapsed]="!expandedDetail" *ngIf="header">
				<div class="od-grid">
					<div class="od-fact" *ngIf="header.deliverydate">
						<span class="od-k">Deliver</span><span class="od-v strong">{{ header.deliverydate | date:'EEE, MMM d' }}</span>
					</div>
					<div class="od-fact" *ngIf="header.shipvia">
						<span class="od-k">Ship via</span><span class="od-v">{{ header.shipvia }}</span>
					</div>
					<div class="od-fact" *ngIf="header.address">
						<span class="od-k">Ship to</span><span class="od-v">{{ header.address }}</span>
					</div>
					<div class="od-fact" *ngIf="header.phone">
						<span class="od-k">Phone</span><span class="od-v">{{ header.phone }}</span>
					</div>
					<div class="od-fact" *ngIf="header.customerref">
						<span class="od-k">Cust PO</span><span class="od-v">{{ header.customerref }}</span>
					</div>
					<div class="od-fact">
						<span class="od-k">Bins</span><span class="od-v">{{ totals.bin_count }}</span>
					</div>
				</div>
				<div class="od-note" *ngIf="header.notes">
					<i class="material-icons">sticky_note_2</i><span>{{ header.notes }}</span>
				</div>
			</section>

			<!-- Scan bar. Hidden sink first so a wedge scanner never opens the keyboard. -->
			<section class="scan-bar sticky" (click)="focusSink()">
				<input #dwSinkOrder class="dw-sink" type="text" autocomplete="off" autocorrect="off"
					autocapitalize="off" spellcheck="false" inputmode="none" tabindex="0"
					(input)="onSinkInput($event)" />
				<div class="scan-ready" [class.scanning]="keyBuffer.length > 0"
					[class.mode-manual]="scanMode === 'manual'" (click)="toggleManual()">
					<i class="material-icons">{{ keyBuffer.length ? 'wifi_tethering' : (scanMode === 'manual' ? 'edit' : 'qr_code_scanner') }}</i>
					<div class="scan-text">
						<span class="scan-label">{{ keyBuffer.length ? 'Scanning…' : (scanMode === 'manual' ? 'Type a SKU or barcode' : scanHint) }}</span>
						<span class="scan-last" *ngIf="!keyBuffer.length && lastScanned">Last: {{ lastScanned }}</span>
					</div>
					<span class="scan-buf" *ngIf="keyBuffer.length">{{ keyBuffer }}</span>
				</div>
				<div class="manual-row" *ngIf="scanMode === 'manual'" (click)="$event.stopPropagation()">
					<i class="material-icons">keyboard</i>
					<input #manualInputOrder type="text" autocapitalize="characters" autocomplete="off"
						placeholder="SKU / part / barcode…" (keydown.enter)="onManualEnter($event)" />
				</div>
				<!-- Counting still saves without the socket; only the live mirroring to
				     the board is lost. Say which, so nobody assumes their taps vanished. -->
				<div class="offline-note" *ngIf="!liveUpdates" (click)="$event.stopPropagation()">
					<i class="material-icons">sync_disabled</i>
					<span>Counts are saving, but the board won't mirror them live.</span>
				</div>
				<div class="offline-note is-bad" *ngIf="failedCounts" (click)="$event.stopPropagation()">
					<i class="material-icons">error</i>
					<span>{{ failedCounts }} count{{ failedCounts === 1 ? '' : 's' }} did not save — re-count those lines.</span>
				</div>

				<div class="feedback" *ngIf="feedback.length">
					<div class="fb" *ngFor="let f of feedback" [ngClass]="'fb-' + f.tone">
						<i class="material-icons">{{ f.tone === 'ok' ? 'check_circle' : f.tone === 'warn' ? 'warning' : f.tone === 'err' ? 'error' : 'info' }}</i>
						<span>{{ f.text }}</span>
					</div>
				</div>
			</section>
			</aside>

			<div class="order-work">
			<div class="ps-loading" *ngIf="loading">
				<mat-progress-spinner mode="indeterminate" diameter="40" color="accent"></mat-progress-spinner>
			</div>

			<div class="ps-error" *ngIf="error">
				<i class="material-icons">error</i> {{ error }}
			</div>

			<!-- Bins are the walk path: unfinished bins float to the top. -->
			<!-- ── Compact: one row per line, strict bin order, the printed-sheet read ── -->
			<section class="line-rows" *ngIf="!loading && density === 'compact' && flatLines.length">
				<div class="lr-head">
					<span class="lrh-item">Item</span>
					<span class="lrh-qty">{{ stage === 'check' ? 'Chk' : 'Pick' }}</span>
				</div>

				<ng-container *ngFor="let l of flatLines; let i = index; trackBy: trackByPickId">
					<!-- A full-width strip, not a column: a product line reads
					     "AUTHENTIC BEAUTY CONCEPT" and would be cut to nothing in a
					     fixed column, and the column stole width the item needed at
					     every screen size. This also matches the printed slip. -->
					<div class="lr-group" *ngIf="isBinStart(i)">
						<span class="lrg-label">{{ groupLabel }}</span>
						<span class="lrg-value">{{ l.group_key || '—' }}</span>
						<span class="lrg-count" *ngIf="groupCount(l.group_key) > 1">{{ groupCount(l.group_key) }} lines</span>
					</div>

					<div class="lr" [id]="'pl-' + l.pick_id"
						[class.complete]="l.complete"
						[class.partial]="l.partial"
						[class.short]="l.short"
						[class.active]="l.pick_id === activePickId"
						(click)="toggleLineExpand(l)">

						<button type="button" class="lr-tick" (click)="toggleLine(l, $event)"
							[attr.aria-label]="(l.complete ? 'Undo ' : 'Complete ') + l.stockid">
							<i class="material-icons">{{ l.complete ? 'check_circle' : 'radio_button_unchecked' }}</i>
						</button>

						<span class="lr-item">
							<span class="lr-sku">{{ l.stockid }}<span class="lr-brand" *ngIf="showBrand && l.brand">{{ l.brand }}</span><span class="lr-binchip" *ngIf="groupBy && groupBy !== 'bin' && l.bin">bin {{ l.bin }}</span></span>
							<span class="lr-desc">{{ l.description }}</span>
						</span>

						<span class="lr-flags">
							<i class="material-icons short" *ngIf="l.short" [title]="stage === 'check' ? 'Short picked' : l.qoh + ' on hand'">warning</i>
						</span>

						<span class="lr-qty">
							<span class="q-now" *ngIf="l.done > 0">{{ l.done | number:'1.0-2' }}<span class="q-sep">/</span></span>
							<span class="q-target">{{ l.target | number:'1.0-2' }}</span>
							<span class="q-uom" *ngIf="l.units">{{ l.units }}</span>
						</span>

						<i class="material-icons lr-chev">{{ expandedLine === l.pick_id ? 'expand_less' : 'expand_more' }}</i>
					</div>

					<!-- Partials only need the ± when they're asked for. -->
					<div class="lr-strip" *ngIf="expandedLine === l.pick_id" (click)="$event.stopPropagation()">
						<span class="lrs-meta">
							<span class="lrs-part" *ngIf="l.mfgpart">{{ l.mfgpart }}</span>
							<span class="lrs-line">line {{ l.linenumber }}</span>
							<span class="lrs-qoh" *ngIf="stage === 'pick'">{{ l.qoh | number:'1.0-2' }} on hand</span>
							<span class="lrs-by" *ngIf="l.userid">by {{ l.userid }}</span>
						</span>
						<span class="lrs-controls">
							<button type="button" class="qty-btn minus" (click)="sub(l, $event)"
								[disabled]="l.done <= 0" aria-label="Remove one"><i class="material-icons">remove</i></button>
							<span class="lrs-count">{{ l.done | number:'1.0-2' }}</span>
							<button type="button" class="qty-btn plus" (click)="add(l, $event)"
								[disabled]="l.complete" aria-label="Add one"><i class="material-icons">add</i></button>
							<button type="button" class="all-btn" (click)="pickAll(l, $event)" *ngIf="!l.complete">All {{ l.remaining | number:'1.0-2' }}</button>
							<button type="button" class="all-btn undo" (click)="clearLine(l, $event)" *ngIf="l.complete">Undo</button>
						</span>
					</div>
				</ng-container>
			</section>

			<section class="bin-list" *ngIf="!loading && density === 'comfort' && binGroups.length">
				<div class="bin-group" *ngFor="let g of binGroups; trackBy: trackByBin" [class.done]="g.done === g.lines.length">
					<div class="bin-head">
						<span class="bin-tag"><i class="material-icons">grid_view</i>{{ g.bin }}</span>
						<span class="bin-count">{{ g.done }}/{{ g.lines.length }}</span>
						<span class="bin-check" *ngIf="g.done === g.lines.length"><i class="material-icons">check_circle</i></span>
					</div>

					<article class="line-card" *ngFor="let l of g.lines; trackBy: trackByPickId"
						[id]="'pl-' + l.pick_id"
						[class.complete]="l.complete"
						[class.partial]="l.partial"
						[class.short]="l.short"
						[class.active]="l.pick_id === activePickId">

						<div class="lc-main">
							<div class="lc-sku">
								<span class="stk">{{ l.stockid }}</span>
								<span class="mfg" *ngIf="l.mfgpart">{{ l.mfgpart }}</span>
							</div>
							<div class="lc-desc">{{ l.description }}</div>
							<div class="lc-flags">
								<span class="lf short" *ngIf="l.short">
									<i class="material-icons">warning</i>{{ stage === 'check' ? 'short picked' : (l.qoh | number:'1.0-2') + ' on hand' }}
								</span>
								<span class="lf picker" *ngIf="l.userid">by {{ l.userid }}</span>
							</div>
						</div>

						<div class="lc-count">
							<div class="lc-remain" *ngIf="!l.complete">
								<span class="rem">{{ l.remaining | number:'1.0-2' }}</span>
								<span class="rem-lbl">{{ stage === 'check' ? 'to check' : 'to pick' }}</span>
							</div>
							<div class="lc-remain is-done" *ngIf="l.complete">
								<i class="material-icons">check_circle</i>
								<span class="rem-lbl">done</span>
							</div>
							<div class="lc-of">{{ l.done | number:'1.0-2' }} / {{ l.target | number:'1.0-2' }}<span class="uom" *ngIf="l.units"> {{ l.units }}</span></div>
							<div class="bar"><div class="fill" [style.width.%]="linePct(l)"></div></div>
						</div>

						<!-- Big targets: this gets used with gloves on, one-handed. -->
						<div class="lc-actions">
							<button type="button" class="qty-btn minus" (click)="sub(l, $event)"
								[disabled]="l.done <= 0" aria-label="Remove one">
								<i class="material-icons">remove</i>
							</button>
							<button type="button" class="qty-btn plus" (click)="add(l, $event)"
								[disabled]="l.complete" aria-label="Add one">
								<i class="material-icons">add</i>
							</button>
							<button type="button" class="all-btn" (click)="pickAll(l, $event)" *ngIf="!l.complete">
								All {{ l.remaining | number:'1.0-2' }}
							</button>
							<button type="button" class="all-btn undo" (click)="clearLine(l, $event)" *ngIf="l.complete">
								Undo
							</button>
						</div>
					</article>
				</div>
			</section>

			<div class="ps-empty" *ngIf="!loading && !flatLines.length && !error">
				<i class="material-icons">inbox</i>
				<p>Nothing left to {{ stage === 'check' ? 'check' : 'pick' }} on this order.</p>
				<button type="button" class="text-btn" (click)="backToQueue()">Back to the queue</button>
			</div>
			</div>
		</div>

		<!-- Sticky close-out. Says what's still open rather than just going grey. -->
		<footer class="pick-footer" *ngIf="!loading && flatLines.length">
			<div class="pf-status">
				<div class="pf-line">
					<strong>{{ totals.lines_done }}/{{ totals.line_count }}</strong> lines
					<span class="dot">·</span>
					<strong>{{ totals.qty_picked | number:'1.0-2' }}</strong>/{{ totals.qty_pick | number:'1.0-2' }} units
				</div>
				<div class="pf-warn" *ngIf="shortLines">
					<i class="material-icons">warning</i>{{ shortLines }} line{{ shortLines === 1 ? '' : 's' }} short
				</div>
				<div class="pf-invoice" *ngIf="autoInvoiceArmed && allPicked">
					<i class="material-icons">receipt_long</i>Closing this will invoice the order
				</div>
			</div>
			<button type="button" class="complete-btn" [class.ready]="allPicked"
				[disabled]="completing || totals.qty_picked <= 0" (click)="completePick()">
				<i class="material-icons">{{ allPicked ? (autoInvoiceArmed ? 'receipt_long' : 'check_circle') : 'flag' }}</i>
				{{ completeLabel }}
			</button>
		</footer>
	</ng-container>

</div>
</div>
